/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ModalGeneric, Table, Loader } from 'ypf-pas-general-ui-components';

import { statusEnum } from '../../utils/dataStatus';
import { getModalMultipleServiceRequest } from '../../services/serviceRequest';
import { formatDate } from '../../utils/formatUtils';
import LoaderContext from '../../context/LoaderProvider';

const MultipleServiceRequestModal = (props) => {
  const {
    showModalMultipleServiceRequest,
    setShowModalMultipleServiceRequest,
    idSolicitudMultiple
  } = props;
  const closeModal = () => {
    setShowModalMultipleServiceRequest(false);
  };

  const [dataMultipleRequest, setdataMultipleRequest] = useState([]);
  const { setLoader } = useContext(LoaderContext);
  const [loading, setLoading] = useState(false);

  const redirectUrl = ({ id }) => `/detail/${id}`;

  const linkMultipleSDS = ({ cell, value }) => {
    if (cell.row.original?.redireccionPermitida) {
      return (
        <Link
          onClick={closeModal}
          style={{
            textDecoration: 'none',
            color: '#0063bd'
          }}
          to={redirectUrl(cell.row.original)}
        >
          {value}
        </Link>
      );
    }

    return value;
  };

  const columnsModal = [
    {
      Header: 'N°',
      accessor: 'numeroSolicitud',
      Cell: linkMultipleSDS,
      hideSort: true
    },
    {
      Header: 'Servicio',
      accessor: 'servicio',
      hideSort: true,
      style: {
        fontWeight: '600'
      }
    },
    {
      Header: 'F.Probable de realización',
      accessor: 'fechaPosibleRealizacion',
      Cell: formatDate,
      hideSort: true,
      style: {
        width: '120px'
      }
    }
  ];
  const fetchDataMultiple = async () => {
    try {
      setLoading(true);
      const response = await getModalMultipleServiceRequest(idSolicitudMultiple);
      const newResponse = response.filter((item) => item.estadoEnum !== statusEnum.borrador);

      setLoading(false);

      setdataMultipleRequest(newResponse);
    } catch (err) {
      setLoading(false);
    }
    <Loader show={loading} text="Cargando" />;
  };

  useEffect(() => {
    setLoader(true);
    fetchDataMultiple()
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
  }, [idSolicitudMultiple]);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => closeModal()}
      primaryAction={() => {}}
      primaryActionDisabled
      primaryActionLabel=""
      secondaryAction={() => closeModal()}
      secondaryActionLabel="Salir"
      show={showModalMultipleServiceRequest}
      size="lg"
      title="Solicitudes de servicio relacionadas"
    >
      <div className="modal_multiple_service_request">
        {dataMultipleRequest && (
          <Table columns={columnsModal} data={dataMultipleRequest} titleLeft type="light" />
        )}
      </div>
    </ModalGeneric>
  );
};

MultipleServiceRequestModal.propTypes = {
  showModalMultipleServiceRequest: PropTypes.bool,
  setShowModalMultipleServiceRequest: PropTypes.func,
  idSolicitudMultiple: PropTypes.number.isRequired
};
MultipleServiceRequestModal.defaultProps = {
  showModalMultipleServiceRequest: false,
  setShowModalMultipleServiceRequest: () => {
    /* empty */
  }
};

export default MultipleServiceRequestModal;
